
import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-visitor-otp-verification',
  templateUrl: './visitor-otp-verification.component.html',
  styleUrls: ['./visitor-otp-verification.component.scss']
})
export class VisitorOtpVerificationComponent implements OnInit {

  termsAccepted: boolean = false;
  termsError: boolean = false;
  phoneNumber: string;
  otp: string;
  constructor(public appservice:AppService,private toastr: ToastrService, public router: Router) {

    this.phoneNumber = this.appservice.getItem("Phone_Number");

   }


   verifyOTP() {
  if (!this.termsAccepted) {
      this.termsError = true; 
      return; 
    }

  this.termsError = false;
    this.appservice.get("Api/Visitor/ValidateOTP?Phone_No=" + this.phoneNumber + "&otpCode=" + this.otp).subscribe((res: any) => {
      if(res=="True")
      {
    
        return this.router.navigate(['/visitor-entry']);
      }
      else
      {
        this.toastr.error('Error ', res, {
          timeOut: 3000
        });
      }

    });
  }

  ngOnInit(): void {
    this.appservice.Company = "_"+this.appservice.getItem("Company");;
    
    this.appservice.get_Area_Details();
  }

}
